export default (className: string, classes: string[], isResolved: boolean) => {
    if (isResolved) {
        classes.push(className);
    }
}